import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { ServerUnreachable } from 'components/ServerUnreachable';
import { useAuth } from 'contexts/AuthContext';
import { isTotadminUser } from 'utils/auth';

export function GuestGuard({ children }: { children: ReactNode }): ReactNode {
    const { user, loading, unreachable, retry } = useAuth();

    if (loading) return null;

    // Comme AuthGuard : des tokens sont présents mais l'API n'a pas répondu. Afficher le formulaire
    // de connexion ferait croire à une déconnexion ; une fois l'API revenue, Réessayer redirige
    // vers l'accueil si la session est intacte.
    if (unreachable) return <ServerUnreachable onRetry={retry} />;

    if (user && isTotadminUser(user)) {
        return <Navigate to="/" replace />;
    }

    return children;
}
